// extracted by mini-css-extract-plugin
export default {"cta_button":"styles_cta_button__+J6su","shopee":"styles_shopee__ZYuA4","arrow":"styles_arrow__A2iBG"};